import { ComponentProps, PropsWithChildren } from 'react'

import { JourneyPaneProvider } from './JourneyPaneProvider'
import { JourneyRouter } from './JourneyRouter'

export const JourneyProvider = ({ children, ...props }: PropsWithChildren<ComponentProps<typeof JourneyRouter>>) => {
  return <JourneyPaneProvider {...props}>{children}</JourneyPaneProvider>
}
